import { render, staticRenderFns } from "./TextTruncate.vue?vue&type=template&id=82db64b6&scoped=true&"
import script from "./TextTruncate.vue?vue&type=script&lang=js&"
export * from "./TextTruncate.vue?vue&type=script&lang=js&"
import style0 from "./TextTruncate.vue?vue&type=style&index=0&id=82db64b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82db64b6",
  null
  
)

export default component.exports